import TableAdmin from './views/TransferTableAdmin.c';
export default TableAdmin;
